<div [ngClass]="widgetCssClassName()"
     class="search-widget-v4-mobile">
  <div class="search-widget-v4-mobile__free-search">
    <div class="input-wrap grow">
      <mat-form-field appearance="outline">
        <div [formGroup]="freeSearchForm" class="search-wrapper">
          <div class="search-icon-wrapper">
            <app-ui-icon color="var(--grey-3)" name="search" size="md"></app-ui-icon>
          </div>
          <input
            (focus)="onFreeSearchFocus($event)"
            autoComplete="off"
            class="test-search-autocomplete-input"
            formControlName="term"
            matInput
            placeholder="Sök efter vårdtjänst, mottagning eller ort"
            type="search"
          >
          @if (isTermFreeSearchNotEmpty()) {
            <div
              (click)="onFreeSearchClear()"
              class="close-icon-wrapper"
            >
              <app-ui-icon color="var(--grey-3)" name="close" size="md"></app-ui-icon>
            </div>
          }
        </div>
      </mat-form-field>

    </div>
  </div>
  @if (hideFiltersAndPlacePanel() !== true) {
    <div class="search-widget-v4-mobile__filters-buttons">
      <app-ui-button
        (onClick)="onPlaceClick($event)"
        [color]="(state() && state().autocompletePlaceCurrentValue !== '' ? 'outline-tertiary-green' : 'outline-tertiary')"
        [disabled]="false"
        [expanded]="'inline'"
        [size]="'sm'"
        class="test-places-filter-button"
      >
        <app-ui-icon name="marker"></app-ui-icon>
        {{ (state() && state().autocompletePlaceCurrentValue !== '' ? state().autocompletePlaceCurrentValue : 'Välj plats') }}
      </app-ui-button>

      <!--    <app-ui-button-->
      <!--      (onClick)="onFiltersClick($event)"-->
      <!--      [buttonClass]="(state() && state().numberOfSelectedFilters > 0 ? 'with-badge' : '')"-->
      <!--      [color]="(state() && state().numberOfSelectedFilters > 0 ? 'outline-tertiary-green' : 'outline-tertiary')"-->
      <!--      [disabled]="false"-->
      <!--      [expanded]="'inline'"-->
      <!--      [size]="'sm'"-->
      <!--      class="test-filters-filter-button"-->
      <!--    >-->
      <!--      <app-ui-icon name="filter_slide"></app-ui-icon>-->
      <!--      {{ (state() && state().numberOfSelectedFilters > 0 ? 'Filter' : 'Fler filter') }}-->
      <!--      <vdn-badge *ngIf="state() && state().numberOfSelectedFilters > 0" [color]="'dark'">{{-->
      <!--          state().numberOfSelectedFilters-->
      <!--        }}-->
      <!--      </vdn-badge>-->
      <!--    </app-ui-button>-->
    </div>
  }

  @if (theme() === SearchWidgetThemeEnum.HOME) {
    <div class="search-widget-v4-mobile__mega-menu-button">
      <app-ui-button
        (onClick)="onCategoriesClick()"
        [color]="
        isMobileWidgetExpanded() === true
          ? 'tertiary'
          : 'outline-green'
      "
        [disabled]="false"
        [expanded]="'block'"
        [size]="theme() === SearchWidgetThemeEnum.HOME &&
      isMobileWidgetExpanded() === false ? 'lg' : 'md'"
        class="test-mega-menu-button"
      >
        <app-ui-icon color="var(--green-2)" name="list"></app-ui-icon>
        Alla kategorier
      </app-ui-button>
    </div>
  }

</div>

@defer {
  <app-search-categories-mobile-panel></app-search-categories-mobile-panel>
  <app-search-places-mobile-panel></app-search-places-mobile-panel>
} @placeholder (minimum 4s) {
  <div></div>
}
